<template>
	<div>
		<div class="border-bottom pb-3 mb-6">
            <div class="display-3 kp-title">{{item.name}}</div>
        </div>
        <div class="border-bottom pb-3 mb-7">
            <div class="d-flex align-items-center mb-5">
                <h3 class="card-title mb-0 text-muted">Track Information</h3>                            
            </div>
            <div>
                <div class="row mb-2">
                    <label class="col-sm-3">Name</label>
                    <div class="col-sm-6">
                        <span>{{item.name}}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Description</label>
                    <div class="col-sm-6">
                        <span>{{item.description}}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Created</label>
                    <div class="col-sm-6">
                        <span>{{item.createdAt | df}}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Objects</label>
                    <div class="col-sm-6">
                        <router-link :to="{name: 'track-objects', params: {id: item.id}}">Explore Objects</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="border-bottom pb-3 mb-7">
		    <div class="d-flex align-items-center mb-5">
		        <h3 class="card-title mb-0 text-muted">
		            Buckets
		        </h3>
		    </div>
		    <div>
		        <table class="table table-vcenter table-edge">
		            <thead>
		                <tr>
		                    <th class="w-25">
		                        Name
		                    </th>
		                    <th>
		                        Description
		                    </th>
		                    <th>
		                        ID
		                    </th>
		                    <th>
		                        Created
		                    </th>		                    
		                </tr>
		            </thead>
		            <tbody>
		                <tr v-for="bucket in item.track_buckets">
		                    <td>
		                        <router-link :to="{name: 'bucket-details', params: {id: bucket.id}}">{{bucket.name}}</router-link>
		                    </td>
		                    <td>{{bucket.description}}</td>
		                    <td>{{bucket.id}}</td>
		                    <td>{{bucket.createdAt | df}}</td>                    
		                </tr>		                                
		            </tbody>
		        </table>
		    </div>
		</div>
		<div class="border-bottom pb-3 mb-7">
		    <div class="d-flex align-items-center mb-5">
		        <h3 class="card-title mb-0 text-muted">
		            Observers
		        </h3>
		    </div>
		    <div class="row">
		        <div class="col-12">
		            <table class="table card-table table-edge">
		                <thead>
		                    <tr>
		                        <th>
		                            Name
		                        </th>
		                        <th>
		                            Email
		                        </th>
		                        <th>
		                        	Observing ID
		                        </th>
		                        <th>
		                        	Status
		                        </th>
		                        <th>
		                            Added
		                        </th>
		                        <th>
		                        	Action
		                        </th>
		                    </tr>
		                </thead>
		                <tbody>
		                    <tr v-for="track_observer in item.track_observers">
		                        <td>
		                            <span class="text-muted mr-3">
		                                <i class="fe fe-user">
		                                </i>
		                            </span>
		                            <router-link :to="{name: 'user-details'}">
		                            	{{`${track_observer.observer.fname} ${track_observer.observer.lname}`}}
		                            </router-link>
		                        </td>
		                        <td>
		                            {{track_observer.observer.email}}
		                        </td>
		                        <td>
		                            <router-link :to="{name: 'observer-details', params: {id: track_observer.id}}">
		                            	{{track_observer.id}}
		                            </router-link>
		                        </td>
		                        <td>
			                    	<span class="tag tag-success" v-if="track_observer.isActive">Active</span>
			                    	<span class="tag tag-pink" v-else>Disabled</span>
			                    </td>
		                        <td>
		                            {{track_observer.createdAt | df}}
		                        </td>
		                        <td>
		                        	<ToogleStatus :is-active="track_observer.isActive" :observing-id="track_observer.id" :key="track_observer.id" />
		                        </td>
		                    </tr>		                    	                    
		                </tbody>
		            </table>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import {HTTP} from '@/components/HTTP.js'
	import DateFormat from '@/components/DateFilter.js'
	import ToogleStatus from '@/components/ToogleStatus'

	export default {
		created: function(){
			this.id = this.$route.params.id;
			this.fetch()
		},
		filters: {
			df: DateFormat
		},
		components: {
			ToogleStatus
		},
		data: function(){
			return {
				id: "",
				item: {
					track_buckets: [],
					track_observers: [{observer: {}}]
				}
			}
		},
		methods: {
			fetch: function(){
				HTTP.get('e/track/' + this.id)
	  			.then((res) => {
	  				if (res.data.status) {
	  					this.item = res.data.data.track;
	  				}	  				
	  			})
	  			.catch((e) => {
	  				console.log("Error response", e);
	  			})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/tracks/TrackDetails.vue